import { StyleSheet } from 'react-native';
import { useTheme } from '../../hooks/useTheme';
import { useStyleVars } from '../../hooks/useStyleVars';
export function useStyle({ kidtoken, scalable, customStyle, }) {
    var _a, _b, _c;
    const { componentStyle: { tabs: { tab_color_slider, tab_color_active_text, tab_color_text, tab_color_tab_bar_bg, tab_size_text, tab_size_text_primary, tab_size_text_primary_half, tab_size_text_secondary, tab_size_tab_item_padding_horizontal, tab_size_tab_item_padding_horizontal_primary, tab_size_tab_item_padding_horizontal_primary_half, tab_size_tab_item_padding_horizontal_secondary, tab_size_tab_bar_height_primary, tab_size_tab_bar_height_primary_half, tab_size_tab_bar_height_secondary, tab_size_slider_bottom, tab_size_slider_bottom_primary, tab_size_slider_bottom_primaryHalf, tab_size_slider_bottom_secondary, tab_size_slider_height, tab_size_slider_border_radius, tab_size_text_weight, tab_size_text_active_weight, tab_size_tab_bar_height, tab_size_tab_bar_content_padding_bottom, tab_content_width, tab_content_container_width, }, }, } = useTheme();
    const { textColor, textActiveColor, sliderColor, sliderHeight, textSize, sliderBorderRadius, sliderBottom, tabBarBgColor, tabBarHeight, tabContentWidth, tabContentContainerWidth, tabItemPaddingHorizontal, } = customStyle;
    const defaultVars = {
        kid_tab_color_slider: tab_color_slider,
        kid_tab_color_active_text: tab_color_active_text,
        kid_tab_color_text: tab_color_text,
        kid_tab_color_tab_bar_bg: tab_color_tab_bar_bg,
        kid_tab_size_text: tab_size_text,
        kid_tab_size_text_primary: tab_size_text_primary,
        kid_tab_size_text_primary_half: tab_size_text_primary_half,
        kid_tab_size_text_secondary: tab_size_text_secondary,
        kid_tab_size_tab_item_padding_horizontal: tab_size_tab_item_padding_horizontal,
        kid_tab_size_tab_item_padding_horizontal_primary: tab_size_tab_item_padding_horizontal_primary,
        kid_tab_size_tab_item_padding_horizontal_primary_half: tab_size_tab_item_padding_horizontal_primary_half,
        kid_tab_size_tab_item_padding_horizontal_secondary: tab_size_tab_item_padding_horizontal_secondary,
        kid_tab_size_tab_bar_height_primary: tab_size_tab_bar_height_primary,
        kid_tab_size_tab_bar_height_primary_half: tab_size_tab_bar_height_primary_half,
        kid_tab_size_tab_bar_height_secondary: tab_size_tab_bar_height_secondary,
        kid_tab_size_slider_bottom: tab_size_slider_bottom,
        kid_tab_size_slider_bottom_primary: tab_size_slider_bottom_primary,
        kid_tab_size_slider_bottom_primaryHalf: tab_size_slider_bottom_primaryHalf,
        kid_tab_size_slider_bottom_secondary: tab_size_slider_bottom_secondary,
        kid_tab_size_slider_height: tab_size_slider_height,
        kid_tab_size_slider_border_radius: tab_size_slider_border_radius,
        kid_tab_size_text_weight: tab_size_text_weight,
        kid_tab_size_text_active_weight: tab_size_text_active_weight,
        kid_tab_size_tab_bar_height: tab_size_tab_bar_height,
        kid_tab_size_tab_bar_content_padding_bottom: tab_size_tab_bar_content_padding_bottom,
        kid_tab_content_width: tab_content_width,
        kid_tab_content_container_width: tab_content_container_width,
    };
    const customVars = {
        kid_tab_size_text: textSize,
        kid_tab_color_text: textColor,
        kid_tab_color_active_text: textActiveColor,
        kid_tab_color_slider: sliderColor,
        kid_tab_color_tab_bar_bg: tabBarBgColor,
        kid_tab_size_tab_bar_height: tabBarHeight,
        kid_tab_size_slider_height: sliderHeight,
        kid_tab_size_slider_border_radius: sliderBorderRadius,
        kid_tab_size_slider_bottom: sliderBottom,
        kid_tab_content_width: tabContentWidth,
        kid_tab_content_container_width: tabContentContainerWidth,
        kid_tab_size_tab_item_padding_horizontal: tabItemPaddingHorizontal,
        kid_tab_size_tab_item_padding_horizontal_primary: tabItemPaddingHorizontal,
        kid_tab_size_tab_item_padding_horizontal_primary_half: tabItemPaddingHorizontal,
        kid_tab_size_tab_item_padding_horizontal_secondary: tabItemPaddingHorizontal,
    };
    const vars = useStyleVars({
        defaultVars,
        customVars,
        scalable,
        kidtoken,
    });
    return {
        vars,
        style: StyleSheet.create({
            container: {
                backgroundColor: 'transparent',
                flex: 1,
            },
            tabBar: {
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                minWidth: '100%',
                backgroundColor: vars.kid_tab_color_tab_bar_bg,
                height: vars.kid_tab_size_tab_bar_height,
            },
            tabBarContentContainerStyle: {
                height: '100%',
                paddingBottom: vars.kid_tab_size_tab_bar_content_padding_bottom,
                alignItems: 'center',
            },
            slider: {
                position: 'absolute',
                height: vars.kid_tab_size_slider_height,
                borderRadius: vars.kid_tab_size_slider_border_radius,
                backgroundColor: vars.kid_tab_color_slider,
            },
            primarySlider: {
                bottom: (_a = vars.kid_tab_size_slider_bottom) !== null && _a !== void 0 ? _a : vars.kid_tab_size_slider_bottom_primary,
            },
            primaryHalfSlider: {
                bottom: (_b = vars.kid_tab_size_slider_bottom) !== null && _b !== void 0 ? _b : vars.kid_tab_size_slider_bottom_primaryHalf,
            },
            secondarySlider: {
                bottom: (_c = vars.kid_tab_size_slider_bottom) !== null && _c !== void 0 ? _c : vars.kid_tab_size_slider_bottom_secondary,
            },
            tabItem: {
                paddingHorizontal: vars.kid_tab_size_tab_item_padding_horizontal,
                height: vars.kid_tab_size_tab_bar_height,
            },
            primaryTabItem: {
                paddingHorizontal: vars.kid_tab_size_tab_item_padding_horizontal_primary,
                height: vars.kid_tab_size_tab_bar_height_primary,
            },
            primaryHalfTabItem: {
                paddingHorizontal: vars.kid_tab_size_tab_item_padding_horizontal_primary_half,
                height: vars.kid_tab_size_tab_bar_height_primary_half,
            },
            secondaryTabItem: {
                paddingHorizontal: vars.kid_tab_size_tab_item_padding_horizontal_secondary,
                height: vars.kid_tab_size_tab_bar_height_secondary,
            },
            tabItemText: {
                //单行文本无需设置行高
                fontSize: vars.kid_tab_size_text,
            },
            primaryTabItemText: {
                fontSize: vars.kid_tab_size_text_primary,
            },
            primaryHalfTabItemText: {
                fontSize: vars.kid_tab_size_text_primary_half,
            },
            secondaryTabItemText: {
                fontSize: vars.kid_tab_size_text_secondary,
            },
        }),
    };
}
